import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IListOwnExternalPropertiesData,
  IMyDealsMetricsData,
} from '@shared/models/my-deals';
import { PROPERTY_LIST_FRAGMENT } from './properties.queries';

export const EXTERNAL_PROPERTY_USER_LISTING_FRAGMENT = gql`
  ${PROPERTY_LIST_FRAGMENT}
  fragment ExternalPropertyUserListingFragment on ExternalPropertyUserListing {
    id
    hasMatch
    normalizedAddress
    insertedAt
    arv
    renovationCostEstimate
    repairEstimate
    price
    askingPrice
    status
    userStatus

    bathrooms
    bedrooms
    buildingArea
    propertyType

    marketplaceProperty {
      ...PropertyListFragment
      totalOffers
    }

    openTitleOrders {
      id
      status
    }
  }
`;

export const LIST_OWN_EXTERNAL_PROPERTIES: TypedDocumentNode<IListOwnExternalPropertiesData> = gql`
  ${EXTERNAL_PROPERTY_USER_LISTING_FRAGMENT}
  query listOwnExternalProperties($isLoggedIn: Boolean! = true) {
    listOwnExternalProperties {
      ...ExternalPropertyUserListingFragment
    }
  }
`;

export const MY_DEALS_METRICS: TypedDocumentNode<IMyDealsMetricsData> = gql`
  query self {
    self {
      id
      totalExternalProperties
      totalMatchedExternalProperties
      totalNotMatchedExternalProperties
      totalPipelineExternalProperties
    }
  }
`;
